import request from './request'

// 服务费分配规则接口
export function getCommissionAllocationRules(params) {
  return request.get('/admin/commission-allocation-rules', { params })
}

export function createCommissionAllocationRule(data) {
  return request.post('/admin/commission-allocation-rules', data)
}

export function updateCommissionAllocationRule(id, data) {
  return request.put(`/admin/commission-allocation-rules/${id}`, data)
}

export function deleteCommissionAllocationRule(id) {
  return request.delete(`/admin/commission-allocation-rules/${id}`)
}

// 批量保存：针对一个服务费单项，为每位角色单独设置分佣方式/比例/固定金额
export function batchSaveCommissionAllocationRules(data) {
  return request.post('/admin/commission-allocation-rules/batch', data)
}
